import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DataedoDownloadsService {
    constructor(http) {
        this.http = http;
    }
    getDownloads() {
        return this.http.get(`${environment.apiUrl}v1/dataedo-downloads`);
    }
}
DataedoDownloadsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataedoDownloadsService_Factory() { return new DataedoDownloadsService(i0.ɵɵinject(i1.HttpClient)); }, token: DataedoDownloadsService, providedIn: "root" });
